import(/* webpackMode: "eager" */ "/app/landing/src/app/kontakt/page.tsx");
